import React from 'react';

const PolitiqueConfidentialitePage = () => {
  return (
    <div data-testid="politique-confidentialite-page">
      <section className="pt-32 pb-20 bg-[#0e1c3f]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#0078b7] font-bold tracking-[0.2em] uppercase text-sm mb-4">Protection des données</p>
            <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
              Politique de Confidentialité
            </h1>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">

          <p className="text-slate-600 leading-relaxed mb-8 text-lg">
            SOPREL GROUPE accorde une grande importance à la protection de vos données personnelles. La présente politique de confidentialité a pour objet de vous informer sur la manière dont nous collectons, traitons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">1. Responsable du traitement</h2>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <p className="text-slate-700 leading-relaxed mb-1"><strong>SOPREL GROUPE</strong></p>
            <p className="text-slate-600 leading-relaxed mb-1">32 rue de Cambrai, 75019 Paris</p>
            <p className="text-slate-600 leading-relaxed mb-1">Téléphone : 01 55 34 79 20</p>
            <p className="text-slate-600 leading-relaxed">Email : contact@soprel-groupe.fr</p>
          </div>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">2. Données collectées</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Nous collectons les données personnelles suivantes dans le cadre de l'utilisation de notre site :
          </p>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <h3 className="font-heading font-bold text-lg text-[#0e1c3f] mb-3">Via le formulaire de contact :</h3>
            <ul className="list-disc list-inside text-slate-600 space-y-1">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone (facultatif)</li>
              <li>Nom de la société (facultatif)</li>
              <li>Objet et contenu du message</li>
            </ul>
          </div>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <h3 className="font-heading font-bold text-lg text-[#0e1c3f] mb-3">Données de navigation :</h3>
            <ul className="list-disc list-inside text-slate-600 space-y-1">
              <li>Adresse IP</li>
              <li>Type de navigateur</li>
              <li>Pages consultées et durée de visite</li>
              <li>Données de cookies techniques</li>
            </ul>
          </div>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">3. Finalités du traitement</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Vos données personnelles sont collectées et traitées pour les finalités suivantes :
          </p>
          <ul className="list-disc list-inside text-slate-600 space-y-2 mb-8">
            <li>Répondre à vos demandes de contact et de devis</li>
            <li>Gérer la relation commerciale</li>
            <li>Améliorer notre site et nos services</li>
            <li>Assurer le bon fonctionnement technique du site</li>
            <li>Respecter nos obligations légales et réglementaires</li>
          </ul>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">4. Base légale du traitement</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Le traitement de vos données personnelles est fondé sur :
          </p>
          <ul className="list-disc list-inside text-slate-600 space-y-2 mb-8">
            <li><strong>Votre consentement</strong> : lorsque vous remplissez le formulaire de contact</li>
            <li><strong>L'intérêt légitime</strong> de SOPREL GROUPE : pour l'amélioration de nos services et la gestion de la relation client</li>
            <li><strong>L'exécution d'un contrat</strong> : dans le cadre de nos relations commerciales</li>
          </ul>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">5. Destinataires des données</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Vos données personnelles sont destinées aux services internes de SOPREL GROUPE (service commercial, bureau d'études, direction) dans le cadre de leurs missions respectives. Elles ne sont en aucun cas cédées, vendues ou partagées avec des tiers à des fins commerciales.
          </p>
          <p className="text-slate-600 leading-relaxed mb-8">
            Elles peuvent être communiquées à des sous-traitants techniques (hébergeur du site) dans le strict cadre de l'exécution de leurs prestations et dans le respect du RGPD.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">6. Durée de conservation</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Vos données personnelles sont conservées pour une durée proportionnée à la finalité du traitement :
          </p>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <div className="space-y-3">
              <div className="flex justify-between border-b border-slate-200 pb-2">
                <span className="text-slate-600">Données du formulaire de contact</span>
                <span className="text-[#0e1c3f] font-medium">3 ans</span>
              </div>
              <div className="flex justify-between border-b border-slate-200 pb-2">
                <span className="text-slate-600">Données de navigation (logs)</span>
                <span className="text-[#0e1c3f] font-medium">13 mois</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-600">Cookies techniques</span>
                <span className="text-[#0e1c3f] font-medium">Durée de la session</span>
              </div>
            </div>
          </div>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">7. Vos droits</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            {[
              { title: 'Droit d\'accès', desc: 'Obtenir la confirmation que vos données sont traitées et en obtenir une copie.' },
              { title: 'Droit de rectification', desc: 'Demander la correction de données inexactes ou incomplètes.' },
              { title: 'Droit d\'effacement', desc: 'Demander la suppression de vos données dans les conditions prévues par la loi.' },
              { title: 'Droit à la limitation', desc: 'Demander la limitation du traitement de vos données.' },
              { title: 'Droit à la portabilité', desc: 'Recevoir vos données dans un format structuré et couramment utilisé.' },
              { title: 'Droit d\'opposition', desc: 'Vous opposer au traitement de vos données pour des motifs légitimes.' },
            ].map((right, i) => (
              <div key={i} className="bg-slate-50 border border-slate-200 p-4">
                <h4 className="font-heading font-bold text-sm text-[#0e1c3f] mb-1">{right.title}</h4>
                <p className="text-slate-500 text-sm">{right.desc}</p>
              </div>
            ))}
          </div>
          <p className="text-slate-600 leading-relaxed mb-8">
            Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@soprel-groupe.fr" className="text-[#0078b7] hover:underline">contact@soprel-groupe.fr</a> ou par courrier à SOPREL GROUPE, 32 rue de Cambrai, 75019 Paris.
          </p>
          <p className="text-slate-600 leading-relaxed mb-8">
            En cas de difficulté, vous disposez également du droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#0078b7] hover:underline">www.cnil.fr</a>.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">8. Cookies</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            Notre site utilise des cookies strictement nécessaires à son bon fonctionnement :
          </p>
          <ul className="list-disc list-inside text-slate-600 space-y-2 mb-8">
            <li><strong>Cookies techniques</strong> : nécessaires à la navigation et au bon fonctionnement du site</li>
            <li><strong>Cookies de session</strong> : permettant de maintenir votre session de navigation</li>
          </ul>
          <p className="text-slate-600 leading-relaxed mb-8">
            Aucun cookie publicitaire ou de tracking n'est utilisé sur ce site. Vous pouvez configurer votre navigateur pour refuser les cookies, étant entendu que cela pourrait affecter le bon fonctionnement du site.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">9. Sécurité</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            SOPREL GROUPE met en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité de vos données personnelles, notamment contre tout accès non autorisé, perte, altération ou divulgation.
          </p>
          <p className="text-slate-600 leading-relaxed mb-8">
            Les communications entre votre navigateur et notre serveur sont chiffrées via le protocole HTTPS/TLS.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">10. Modification de la politique</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            SOPREL GROUPE se réserve le droit de modifier la présente politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec la date de mise à jour. Nous vous invitons à consulter régulièrement cette page.
          </p>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-slate-400 text-sm">
              Dernière mise à jour : Avril 2026
            </p>
          </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialitePage;
